<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Oportunidades</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{ erroMensagem }}</span>
            </div>
          </div>
        </div>
        <v-card>
          <div class="row filtros">
            <div class="col-md-12 btns_center">
                  <button
                  class="btn_1 medium"
                  @click="exportToExcel"
                >Exportar para Excel</button>
            </div>
          </div>
          <v-card-title
            >Suas Oportunidades
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="oportunidades" :search="search" :pagination.sync="pagination">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ moment(props.item.updated_at).format('DD/MM/YYYY') }}</td>
              <td>{{ props.item.cpf }}</td>
              <td>{{ props.item.nome_completo }}</td>
              <td>{{ props.item.number }}</td>
              <td>{{ props.item.email }}</td>
              <td class="text-xs-right">
                <router-link
                  :to="'/uniodonto/oportunidades/detalhes/' + props.item.id"
                >
                <span class="btn_1 gray delete wishlist_close button-content">
                  <i class="fa fa-fw fa-edit"></i> Detalhes
                </span>
                </router-link>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Sua consulta para "{{ search }}" não teve resultado.</v-alert
            >
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao } from "@/utils/util";
import moment from 'moment';
import * as XLSX from 'xlsx';

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      moment: moment,
      search: "",
      erroMensagem: "",
      mostraErro: false,
      headers: [
        { text: "ID", value: "id" },
        { text: "Data", value: "data" },
        { text: "Cpf", value: "cpf" },
        { text: "Nome", value: "name" },
        { text: "Telefone", value: "number" },
        { text: "E-mail", value: "active" },
        { text: "Opções", value: "" },
      ],
      pagination: { sortBy: "id", descending: true },
      oportunidades: [],
      isLoading: false,
    };
  },
  mounted() {
    this.isLoading = true;
    const user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    if (user) {
      ajax("get", `/oportunidades_corretor/${user.id}`)
        .then(res => {
          this.oportunidades = res;
          this.oportunidades.map((oport) => {
            oport.nome_completo = oport.name + " " + oport.last_name;
          })
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          //tratamento_requisicao(error, this);
        });
    } else {
      this.$router.replace(this.$route.query.redirect || "/");
    }
  },
  methods: {
    exportToExcel() {
      const tableData = this.getTableData();
      const ws = XLSX.utils.aoa_to_sheet([this.headers.map(h => h.text), ...tableData]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Oportunidades');
      XLSX.writeFile(wb, 'oportunidades.xlsx');
    },
    getTableData() {
      return this.oportunidades.map(item => [
        item.id,
        moment(item.updated_at).format('DD/MM/YYYY'),
        item.cpf,
        item.nome_completo,
        item.number,
        item.email,
        item.active
      ]);
    },
  },
};
</script>
<style>
    .button-content {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-around;
    }
    .btns_center{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
    }
    .filtros {
      padding: 16px;
    }
</style>
